export function bankSlipPath() {
  return '/bank_slip';
}

export function pixPath() {
  return '/pix';
}
